import { render, staticRenderFns } from "./PopupSitesReport.vue?vue&type=template&id=194ec35d"
import script from "./PopupSitesReport.vue?vue&type=script&lang=js"
export * from "./PopupSitesReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports